import type { Resource } from '../../';
export const country_countries_MD: Resource = {"default":"Moldova"};
